import type { Supplier } from '@/types/supplier-types'

export const getPricingType = (priceTypeValue: string): number => {
  switch (priceTypeValue) {
    case 'CostPerKg':
      return 0;
    case 'CostPerMetre':
      return 1;
    case 'CostPerTest':
      return 2;
    default:
      return -1;
  }
}

export const getAddressTypeEnum = (addressTypeName: string): number => {
  switch (addressTypeName) {
    case 'Invoice Address':
      return 0;
    case 'Delivery Address':
      return 1;
    default:
      return -1;
  }
}

export const retreivePricingType = (number: Number) => {
  switch (number) {
    case 0:
      return { priceTypeValue: 'CostPerKg', priceTypeName: 'Cost Per Kilogram' }
    case 1:
      return { priceTypeValue: 'CostPerMetre', priceTypeName: 'Cost Per Metre' }
    case 2:
      return { priceTypeValue: 'CostPerMetre', priceTypeName: 'Cost Per Metre' }
    default:
      console.warn('unexpected number')
  }
}

export const retreiveAddressType = (number: Number) => {
  switch (number) {
    case 0:
      return { addressTypeValue: 'Invoice', addressTypeName: 'Invoice Address' }
    case 1:
      return { addressTypeValue: 'Delivery', addressTypeName: 'Delivery Address' }
    default:
      console.warn('unexpected number')
  }
}

export const qualityList = [
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'Ts23'
  },
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'Kn93'
  },
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'fn93'
  }
]
export const getSupplier = (id: string, suppliers: Supplier[] | undefined) => {
  const supplier = suppliers?.find((supplier: Supplier) => supplier.id === id)
  return supplier?.name
}